import { render, staticRenderFns } from "./SealSign.vue?vue&type=template&id=28203f40&scoped=true"
import script from "./SealSign.vue?vue&type=script&lang=js"
export * from "./SealSign.vue?vue&type=script&lang=js"
import style0 from "./SealSign.vue?vue&type=style&index=0&id=28203f40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28203f40",
  null
  
)

export default component.exports